export const filters = {
    init: () => {
        const $ = jQuery;

        const categoryFilters = $('.filter-wrapper.category input');
        const subjectFilters = $('.filter-wrapper.subject-type input');

        const mobileCategoryFilters = $('#filters-overlay #mobile-filters .filter-wrapper.category input');
        const mobileSubjectFilters = $('#filters-overlay #mobile-filters .filter-wrapper.subject-type input');

        const triggers = $('.filter-wrapper .filter-heading');

        const mobileTrigger = $('#mobile-filters-trigger');
        const mobileClose = $('#mobile-filters .header-wrapper .close');

        categoryFilters.on('change', (e) => {
            const current = e.currentTarget;

            if (current.id === 'all-cats' && $(current).is(':checked')) {
                $(categoryFilters).not(current).prop('checked', false);
            } else if (current.id === 'all-cats' ) {
                $(current).prop('checked', true);
            } else {
                const checked = $(categoryFilters).not('#all-cats').filter(':checked');

                $('#all-cats').prop('checked', checked.length === 0);
            }
        });

        mobileCategoryFilters.on('change', (e) => {
            const current = e.currentTarget;

            if (current.id === 'mobile-all-cats' && $(current).is(':checked')) {
                $(mobileCategoryFilters).not(current).prop('checked', false);
            } else if (current.id === 'mobile-all-cats' ) {
                $(current).prop('checked', true);
            } else {
                const checked = $(mobileCategoryFilters).not('#mobile-all-cats').filter(':checked');

                $('#mobile-all-cats').prop('checked', checked.length === 0);
            }
        });

        subjectFilters.on('change', (e) => {
            const current = e.currentTarget;

            if (current.id === 'all-subjects' && $(current).is(':checked')) {
                $(subjectFilters).not(current).prop('checked', false);
            } else if (current.id === 'all-subjects' ) {
                $(current).prop('checked', true);
            } else {
                const checked = $(subjectFilters).not('#all-subjects').filter(':checked');

                $('#all-subjects').prop('checked', checked.length === 0);
            }
        });

        mobileSubjectFilters.on('change', (e) => {
            const current = e.currentTarget;

            if (current.id === 'mobile-all-subjects' && $(current).is(':checked')) {
                $(mobileSubjectFilters).not(current).prop('checked', false);
            } else if (current.id === 'mobile-all-subjects' ) {
                $(current).prop('checked', true);
            } else {
                const checked = $(mobileSubjectFilters).not('#mobile-all-subjects').filter(':checked');

                $('#mobile-all-subjects').prop('checked', checked.length === 0);
            }
        });

        triggers.on('click', (e) => {
            const current = e.currentTarget;
            const list = $(current).siblings('.filter-list');
            const icon = $(current).find('svg');
            const number = $(current).find('.number');
            const all_icons = $(triggers).find('svg');
            const all_lists = $(triggers).siblings('.filter-list');

            $(all_icons).not(icon).removeClass('rotate');
            $(icon).toggleClass('rotate');

            $(all_lists).not(list).removeClass('open').slideUp();
            
            if ( $(list).hasClass('open') ) {
                const checkedInputs = $(list).find('input:checked');

                if (checkedInputs.length > 1) {
                    $(number).text(checkedInputs.length).addClass('show');
                } else if (checkedInputs.length === 1) {
                    if ($(checkedInputs[0]).hasClass('all-input')) {
                        $(number).removeClass('show');
                    } else {
                        $(number).text(checkedInputs.length).addClass('show');
                    }
                } else {
                    $(number).removeClass('show');
                }
            }
            
            $(list).toggleClass('open').slideToggle();
        });

        mobileTrigger.on('click', (e) => {
            $('body').addClass('show-overlay');
            setTimeout(() => {
                $('#mobile-filters').slideDown();
            }, 50);
        });

        mobileClose.on('click', (e) => {
            $('#mobile-filters').slideUp();

            setTimeout(() => {
                $('body').removeClass('show-overlay');
            }, 450);
        });

        $('.all-filter-wrapper').on('click', () => {
            $('#filters-overlay #mobile-filters .filter-wrapper input').prop('checked', false);

            $('#filters-overlay #mobile-filters #mobile-all-cats').prop('checked', true);
            $('#filters-overlay #mobile-filters #mobile-all-subjects').prop('checked', true);

            $('#mobile-apply-filters').trigger('click');
        });
    }
}